export const GRADIENTS = {
  gateways: ['rgba(255, 255, 255, 0.87)', 'rgba(255, 255, 255, 0.4)', 'rgba(255, 255, 255, 0)'],
  brus: ['rgba(255, 122, 0, 1)', 'rgba(255, 122, 0, 0.5)', 'rgba(255, 122, 0, 0)'],
  sensors: ['rgba(19, 165, 188, 1)', 'rgba(19, 165, 188, 0.5)', 'rgba(19, 165, 188, 0)'],
};
